import { Img } from "@react-email/components";
import { useAttachmentMetadata } from "@circle-react-shared/BuilderUI/Media/AttachmentContext";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { useParseStyles } from "@circle-react-shared/Emails/VisualEmailBuilder/Design/useParseStyles";
import { stripPx } from "@circle-react-shared/Emails/VisualEmailBuilder/Utils/stripPx";

export interface BulletProp {
  emoji?: string;
  placeholder?: string;
  signed_id?: string;
}

export interface BulletProps {
  bullet: BulletProp;
  styles?: Record<string, StyleValue>;
}

export const Bullet = ({ bullet, styles = {} }: BulletProps) => {
  const { emoji = "", signed_id = "" } = bullet;
  const attachmentMetadata = useAttachmentMetadata(signed_id);
  const inlineStyles = useParseStyles({ styles, defaultStyles: {} });

  if (emoji) {
    return <span>{emoji}</span>;
  }

  const { url } = attachmentMetadata ?? {};
  const imageUrl = bullet.placeholder || url;

  if (imageUrl) {
    return (
      <Img
        src={imageUrl}
        width={stripPx(inlineStyles.width) || 18}
        height={stripPx(inlineStyles.height) || 18}
        alt=""
        style={{
          display: "block",
          borderRadius: "50%",
          objectFit: "cover",
          ...inlineStyles,
        }}
      />
    );
  }

  return null;
};
